/**
 * @generated SignedSource<<aa62d4fc64bc2c74e04363ef91ec33f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type priority_issueFieldPriorityInlineEditFull_PriorityInlineEditView_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditView_fragmentRef";
};
export type priority_issueFieldPriorityInlineEditFull_PriorityInlineEditView_fragmentRef$key = {
  readonly " $data"?: priority_issueFieldPriorityInlineEditFull_PriorityInlineEditView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"priority_issueFieldPriorityInlineEditFull_PriorityInlineEditView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditView_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraPriorityField"
};

(node as any).hash = "a5f9582db120fe1c7d1ede5d19fc0614";

export default node;
